<template>

    <div>

        <transition name="modal">
            <employee-modal
                :employee_id="modal_employee_id"
                :tab="modal_tab"
                @close="modal_employee_id = null"
                @refresh="refresh()"
                v-if="modal_employee_id"
            />
        </transition>

        <h1 class="mt-4">Alla anställda</h1>

        <div class="content-container">

            <div class="row mb-4">

                <div class="col-24 col-md-6">
                    <input type="text"
                           class="form-control new-list-group-field"
                           placeholder="Sök namn, kontaktuppgifter, övriga fält"
                           v-model="settings.query.text"
                    >
                </div>

                <div class="col-24 col-md-4">
                    <select class="form-select new-list-group-field" v-model="settings.query.status">
                        <option :value="null">Status</option>
                        <option>Importerad</option>
                        <option>Inbjuden</option>
                        <option>Aktiverad</option>
                        <option>Inaktiverad</option>
                    </select>
                </div>

                <div class="col-24 col-md-5">
                    <v-select
                        label="name"
                        placeholder="Företag"
                        :options="options.companies"
                        :reduce="company => company.id"
                        v-model="settings.query.company_id"
                    />
                </div>

                <div class="col-24 col-md-9 d-flex justify-content-end" title="Ej ännu färdig">
                    <button class="btn btn-primary btn-sm" @click="openExportModal()">Exportera
                        <div class="tooltip-label">Ladda ner en excel med anställda.</div>
                    </button>
                </div>

            </div>

            <list ref="list" :settings="settings" :query.sync="settings.query" :useCookies="false">
                <div slot="item-row" slot-scope="props">
                    <list-item-row
                        :employee="props.item"
                        display-from="employees"
                        :bulk_selected.sync="bulk_selected"
                        @openEmployeeModal="openEmployeeModal"
                        @refresh="refresh()"
                    />
                </div>
            </list>

        </div>
    </div>
</template>

<script>

import employeeModal from './modal.vue'
import listItemRow from './list-item-row'
import vSelect from 'vue-select'

import lister from '../../../../shared/mixins/lister'
import employeeList from '../../../../shared/mixins/employee-list'

export default {

    mixins: [
        lister,
        employeeList
    ],

    components: {
        employeeModal,
        listItemRow,
        vSelect
    },

    props: {
        options: {
            required: true
        }
    },

    data () {
        return {
            modal_employee_id: null,
            modal_tab: null,

            settings: {
                url: '/employees/list',
                query: {
                    text: '',
                    status: null,
                    company_id: null
                },
                columns: [
                    { column: 'check', name: '', class: 'col-1', sortable: false },
                    { column: 'id', name: 'ID', class: 'col-1', sortable: true, default: true },
                    { column: 'name', name: 'Namn', class: 'col-3', sortable: true },
                    { column: 'phone', name: 'Mobilnummer', class: 'col-3', sortable: true },
                    { column: 'company_name', name: 'Företag', class: 'col-4', sortable: true },
                    { column: 'status', name: 'Status', class: 'col-3', sortable: true },
                    { column: 'created_at', name: 'Registrerad', class: 'col-2', sortable: true },
                    { column: 'last_treatment_at', name: 'Senaste beh.', class: 'col-2', sortable: true }
                ],
                bulk_actions: [
                    { event: 'bulkDisableAccounts', label: 'Inaktivera konton' },
                    { event: 'bulkDeleteAccounts', label: 'Radera konton (rensa all persondata)' }
                ],
                export_fields: [
                    { column: 'id', name: 'ID' },
                    { column: 'name', name: 'För- och efternamn' },
                    { column: 'company_name', name: 'Företag' },
                    { column: 'phone', name: 'Mobilnummer' },

                    // Villkoras om de finns
                    { column: 'email_work', name: 'E-postadress arbete' },
                    { column: 'email_private', name: 'E-postadress privat' },
                    { column: 'workplace_title', name: 'Arbetsplats' },
                    { column: 'employment_number', name: 'Anställningsnummer' },
                    { column: 'cost_center', name: 'Kostnadsställe' },

                    { column: 'status', name: 'Status' },
                    { column: 'created_at', name: 'Registrerad/skapad' },
                    { column: 'invited_at', name: 'Inbjuden' },
                    { column: 'activated_at', name: 'Aktiverad' },

                    { column: 'last_treatment_at', name: 'Senaste behandling' },
                    { column: 'treatments_count', name: 'Antal behandlingar' }
                ]
            }
        }
    }
}
</script>
<style type="text/css">
/* --- Fade transition --- */
.modal-enter-active, .modal-leave-active {
    opacity: 1;
    transition: all 350ms;
}

.modal-enter-active .custom-modal-window, .modal-leave-active .custom-modal-window {
    transform:translate(0, 0);
    transition: all 500ms ease;
}

.modal-enter, .modal-leave-to {
    opacity: 0;
}

.modal-enter .custom-modal-window, .modal-leave-to .custom-modal-window {
    transform:translate(0, -50px);
}
</style>
